<template>
    <md-content class="card md-layout-item md-size-100 md-small-size-100">
        <div class="md-flex-center-center md-form-input md-relative">
            <h1 v-if="add" class="md-title md-form-title">
{{ $t('views.admin.configurations.surcharge.add.createTitle')
                }}
</h1>
            <h1 v-else-if="view" class="md-title md-form-title">
{{
                $t('views.admin.configurations.surcharge.add.viewTitle') }}
</h1>
            <h1 v-else class="md-title" md-form-title>
{{ $t('views.admin.configurations.surcharge.add.editTitle')
                }}
</h1>
            <md-card class="md-form-card md-mt-70">
                <div>
                    <form novalidate class="md-layout-item md-size-100 md-small-size-100"
                          @submit.prevent="validateSurcharge">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getSurchargeValidationClass('name')">
                                    <label for="surcharge-name">{{ $t('views.admin.configurations.surcharge.add.name')
                                        }}</label>
                                    <md-input name="surcharge-name" id="surcharge-name" v-model="surcharge.name"
                                              :disabled="sending || view" />
                                    <span class="md-error" v-if="!$v.surcharge.name.required">{{ $t('views.admin.configurations.surcharge.add.validation.surchargeName') }}</span>
                                </md-field>
                            </div>
                        </div>
                        <md-field :class="getSurchargeValidationClass('type')">
                            <label for="surcharge-type">{{ $t('views.admin.configurations.surcharge.add.surchargeType')
                                }}</label>
                            <md-select :name="'value-select'" :id="'value-select'" v-model="surcharge.type.id"
                                       :disabled="sending || view"
                                       md-dense>
                                <md-option v-for="(value) in values" :key="value.id" :value="value.id">
                                    {{ value.name }}
                                </md-option>
                            </md-select>
                            <span class="md-error" v-if="!$v.surcharge.type.required">{{ $t('views.admin.configurations.surcharge.add.validation.expressionValue') }}</span>
                        </md-field>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field :class="getSurchargeValidationClass('value')">
                                    <label for="surcharge-value">{{ $t('views.admin.configurations.surcharge.add.value')
                                        }}</label>
                                    <span class="md-prefix">%</span>
                                    <md-input name="surcharge-value" id="surcharge-value" v-model="surcharge.value"
                                              :disabled="sending || view" />
                                    <span class="md-error" v-if="!$v.surcharge.value.required">{{ $t('validation.required') }}</span>
                                    <span class="md-error" v-else-if="!$v.surcharge.value.decimal">{{ $t('validation.decimal') }}</span>
                                    <span class="md-error" v-else-if="!$v.surcharge.value.minlength">{{ $t('validation.length', {0: $v.surcharge.value.$params.minLength.min}) }}</span>
                                    <span class="md-error" v-else-if="!$v.surcharge.value.maxlength">{{ $t('validation.length', {0: $v.surcharge.value.$params.maxlength.min}) }}</span>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-100 md-flex-right-align md-mt-30">
                            <conditional-router-link to="/configurations/surcharges">
                                <md-button class="md-form-btn-cancel md-mr-30">
                                    {{ $t('cancel') }}
                                </md-button>
                            </conditional-router-link>
                            <md-button type="submit" class="md-header-btn" :disabled="sending || view">
{{ $t('save') }}
                            </md-button>
                        </div>
                    </form>
                </div>
                <md-progress-bar md-mode="indeterminate" v-if="sending" />
            </md-card>
        </div>
    </md-content>
</template>

<script>
  import {validationMixin} from 'vuelidate';
  import {mapGetters} from 'vuex';
  import {surchargesEndpoint} from '@/services/adsign-backend/endpoints';
  import {SlideYDownTransition, SlideYUpTransition} from 'vue2-transitions';
  import ConditionalRouterLink from '@/components/ConditionalRouterLink';
  import {minLength, required, maxLength, numeric, decimal} from 'vuelidate/lib/validators';

  export default {
    components: {ConditionalRouterLink},
    name: 'SurchargeForm',
    mixins: [validationMixin],
    props: {
      id: {
        type: String,
        default: undefined
      },
      view: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      values: [],
      confirmDeleteSurchargeDialog: {
        active: false,
        id: undefined
      },
      showAddExpressionForm: false,
      surcharge: {
        id: null,
        name: null,
        value: null,
        type: {
          id: null,
          name: null
        }
      },
      surchargeType: {
        id: null,
        name: null,
      },
      userSaved: false,
      sending: false,
      lastUser: null

    }),
    computed: {
      ...mapGetters('auth', ['hasAccess']),
      add: {
        get() {
          return this.id === undefined;
        }
      }
    },
    validations: {
      surcharge: {
        name: {
          required
        },
        value: {
          minLength: minLength(1),
          maxLength: maxLength(10),
          decimal
        },
        type: {
          required
        }
      }
    },
    mounted() {
      if (this.id) {
        this.loadSurcharge(this.id);
      }
      this.loadSurchargesTypeValues();
    },
    methods: {
      loadSurcharge(id) {
        return surchargesEndpoint.getSurcharge(id).then(result => {
          this.surcharge = result.data;
        });
      },
      saveSurcharge() {
        const valueForm = {
          name: this.surcharge.name,
          value: this.surcharge.value,
          surchargeTypeId: this.surcharge.type.id
        }
        surchargesEndpoint.createSurcharge(valueForm)
            .then((response) => {
              this.$router.push('/configurations/surcharges');
            })
            .catch(this.handleServerValidationError)
            .finally(() => {
                  this.sending = false;
                }
            );
      },
      updateSurcharge() {
        const valueForm = {
          id: this.surcharge.id,
          name: this.surcharge.name,
          value: this.surcharge.value,
          surchargeTypeId: this.surcharge.type.id
        }
        surchargesEndpoint.updateSurcharge(valueForm)
            .then((response) => {
              this.$router.push('/configurations/surcharges');
            })
            .catch(this.handleServerValidationError)
            .finally(() => {
                  this.sending = false;
                }
            );
      },
      loadSurchargesTypeValues() {
        return surchargesEndpoint.getAllSurchargeTypes(0, 100).then(result => {
          this.values = result.data.content;
        });
      },
      getSurchargeValidationClass(fieldName) {
        const field = this.$v.surcharge[fieldName];

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateSurcharge() {
        this.$v.surcharge.$touch();
        if (this.$v.surcharge.$invalid) {
          return;
        }
        if (this.surcharge.id) {
          this.updateSurcharge();
        } else {
          this.saveSurcharge();
        }
      }
    }
  }
</script>
